import { useTranslation } from 'react-i18next';

import { Button, Modal, Paragraph, Popover } from '@treams/treams-ui';

export default function ClearTalentReviewGridModal(props: {
	onClose: () => void;
	onConfirm: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Popover visible center onDismiss={props.onClose}>
			<Modal>
				<Modal.Header title={t('common.areYouSure')} onClose={props.onClose} />
				<Modal.Contents>
					<Paragraph>{t('talentReviews.v2.grid.clearConfirm')}</Paragraph>
				</Modal.Contents>
				<Modal.Footer>
					<Button title={t('talentReviews.v2.cancel')} type="secondary" onClick={props.onClose} />
					<Button
						ml={2}
						title={t('talentReviews.v2.menu.clearGrid')}
						type="destructive"
						onClick={props.onConfirm}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
